
import {
  computed,
  defineComponent,
  onMounted,
  ref,
} from 'vue';

import {
  product as ProductApi,
} from '@/api';

import LazyBackgroundMedia from '@/components/LazyBackgroundMedia.vue';
import ProductContent from '@/components/card/ProductContent.vue';
import ProductPost from '@/interfaces/ProductPost';

export default defineComponent({
  components: {
    LazyBackgroundMedia,
    ProductContent,
  },

  props: {
    type: {
      type: String,
      required: false,
      default: () => 'image',
    },
    mediaId: {
      type: String,
      required: false,
      default: () => '0',
    },
    mediaSizes: {
      type: String,
      required: false,
      default: () => btoa('null'),
    },
    backgroundPositionY: {
      type: String,
      required: false,
      default: () => 'top',
    },
    backgroundPositionX: {
      type: String,
      required: false,
      default: () => 'center',
    },
    mediaMobileId: {
      type: String,
      required: false,
      default: () => '0',
    },
    mediaMobileSizes: {
      type: String,
      required: false,
      default: () => btoa('null'),
    },
    backgroundPositionMobileY: {
      type: String,
      required: false,
      default: () => 'same',
    },
    backgroundPositionMobileX: {
      type: String,
      required: false,
      default: () => 'same',
    },
    icon: {
      type: String,
      required: false,
    },
    textAlign: {
      type: String,
      required: false,
      default: () => 'center',
    },
    pageUrl: {
      type: String,
      required: false,
      default: () => null,
    },
    productId: {
      type: String,
      required: false,
      default: () => null,
    },
    productContentFirst: {
      type: String,
      required: false,
      default: () => '0',
    },
    showRecommendationTextSingle: {
      type: String,
      required: false,
      default: () => '0',
    },
    showCalculator: {
      type: String,
      required: false,
      default: () => '0',
    },
    label: {
      type: String,
      required: false,
      default: () => 'Mehr erfahren',
    },
    linkStyle: {
      type: String,
      required: false,
      default: () => 'button',
      validator: (type: string) => ['button', 'link', 'full'].indexOf(type) !== -1,
    },
  },
  setup(props, context) {
    const hasMedia = ['image', 'product'].indexOf(props.type) >= 0 && props.mediaId !== '0';
    const headline = context.slots.headline ? context.slots.headline() : [];
    const hasHeadline = computed(() => (
      headline && headline[0] ? `${headline[0].children}`.trim().length > 0 : false
    ));
    const content = context.slots.default ? context.slots.default() : null;
    const hasContent = computed(() => (
      content && content[0] ? `${content[0].children}`.trim().length > 0 : false
    ));
    const hasUrl = `${props.pageUrl || ''}`.trim().length > 0;
    const showButton = computed<boolean>(() => hasUrl && props.linkStyle === 'button');
    const showLink = computed<boolean>(() => hasUrl && props.linkStyle === 'link');
    const showFullLink = computed<boolean>(() => hasUrl && props.linkStyle === 'full');

    const product = ref<ProductPost | null>(null);
    const showAlternativeRecommendationText = computed<boolean>(() => !!(product.value && props.showRecommendationTextSingle !== '0'));
    const showProductCalculator = computed<boolean>(() => !!(product.value && props.showCalculator !== '0') && !!(window.ioappConfig.env?.CALCULATOR_ACTIVE || false));

    const hovering = ref(false);

    const classes = computed(() => {
      const cClasses = [];

      if (props.type === 'product') {
        cClasses.push('text-start');
      } else {
        cClasses.push(`text-${props.textAlign}`);
      }

      if (props.linkStyle === 'full') {
        cClasses.push('io-card--link');
      }

      if (product.value && product.value.recommended) {
        cClasses.push('io-card--recommended');
      }

      cClasses.push(`io-card--${props.type}`);

      return cClasses;
    });

    onMounted(() => {
      window.runIoEqualize();
      setTimeout(window.runIoEqualize, 10);
      setTimeout(window.runIoEqualize, 50);
      setTimeout(window.runIoEqualize, 100);
      setTimeout(window.runIoEqualize, 250);
      setTimeout(window.runIoEqualize, 500);
      setTimeout(window.runIoEqualize, 1000);

      if (props.type === 'product' && props.productId) {
        ProductApi.get(parseInt(props.productId, 10)).then(($p) => {
          product.value = $p;
        });
      }
    });

    return {
      hasMedia,
      hasHeadline,
      hasUrl,
      hasContent,
      hovering,
      classes,
      product,
      showAlternativeRecommendationText,
      showProductCalculator,
      slots: context.slots,
      showButton,
      showLink,
      showFullLink,
    };
  },
});
